import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Col, Form, Row } from 'react-bootstrap';

import { areYouSure } from 'lib/utils/toast';

import { BRANDS_FOR_DROPDOWN } from 'lib/networking/endpoints';
import { brandCleanupUserActions } from 'lib/enums/BrandCleanupEnums';
import SearchableScrollableSelect from 'components/shared/SearchableScrollableSelect';

function AssignBrandsSection({ selectedProductIds, cleanupBrandsOfSelectedProducts, cancel }) {
  const [selectedBrand, setSelectedBrand] = useState(null);

  return (
    <Row className="mb-2 d-flex align-items-center justify-content-end">
      <Col md={3}>
        <Form.Group className="mb-3">
          <Form.Label>Brand</Form.Label>
          <SearchableScrollableSelect
            onChange={option => setSelectedBrand(option)}
            fetchUrl={BRANDS_FOR_DROPDOWN}
            optionMapper={brand => ({
              label: brand.global_manufacturer_name
                ? `${brand.name} by ${brand.global_manufacturer_name}`
                : brand.name,
              value: brand.id,
            })}
          />
        </Form.Group>
      </Col>
      <Button
        className="mr-3"
        variant="primary"
        disabled={!selectedBrand?.value}
        onClick={() => {
          areYouSure(
            () =>
              cleanupBrandsOfSelectedProducts({
                selected_brand_id: selectedBrand?.value || null,
                selected_brand_cleanup_record_ids: selectedProductIds,
                user_suggested_action: brandCleanupUserActions.ASSIGN_SELECTED_BRAND,
              }),
            'Are you sure you want to Assign the brand to the selected Products?',
          );
        }}
      >
        Assign Brand to Selected Products
      </Button>
      <Button variant="secondary" onClick={cancel}>
        Cancel
      </Button>
      <Button
        className="mr-2 ml-2"
        variant="primary"
        onClick={() => {
          window.open(
            // eslint-disable-next-line
            `/enrich-products/create-brand`,
            '_blank',
          );
        }}
      >
        + New Brand
      </Button>
      <Button
        className="mr-2"
        variant="primary"
        onClick={() => {
          window.open(
            // eslint-disable-next-line
            `/enrich-products/create-manufacturer`,
            '_blank',
          );
        }}
      >
        + New Manufacturer
      </Button>
    </Row>
  );
}

AssignBrandsSection.propTypes = {
  selectedProductIds: PropTypes.array.isRequired,
  cleanupBrandsOfSelectedProducts: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
};

export default AssignBrandsSection;
